import React, { useState, useEffect, useMemo } from 'react';

// SERVICES
import { getOrderCommunication, updateCommunicationMessage } from '../../services';
import { format } from 'date-fns';
import { AgGrid, filters } from '../AgGrid';
import CustomTooltip from '../AgGrid/CustomComponents/CustomTooltip/CustomTooltip';

const gridOptions = {
  //
  tooltipShowDelay: 0,
};

const CommunicationGrid = props => {
  const { orderLineId, editable = true, gridName = 'COMMUNICATION_GRID' } = props;

  const [messages, setMessages] = useState(null);

  const columnDefs = useMemo(
    () => [
      {
        headerName: 'Editable',
        field: 'editable',
        valueGetter: params => {
          return !!params?.data?.inboxMessage && editable ? 'Yes' : 'No';
        },
        filter: filters.set,
        pinned: 'left',
        minWidth: 150,
        maxWidth: 150,
        cellStyle: params => {
          if (params.value === 'Yes') {
            return { color: 'var(--jmi-green)' };
          }
          return null;
        },
      },
      {
        headerName: 'System Time',
        field: 'createdOn',
        filter: false,
        cellRenderer: 'datetime',
      },
      {
        headerName: 'Local Time',
        field: 'createdOn',
        filter: false,
        cellRenderer: 'datetime',
        cellRendererParams: {
          convertToLocalTime: true,
        },
      },
      {
        headerName: 'Type',
        valueGetter: params => {
          return params.data.inboxMessage?.messageTypeLookup.descript ?? params.data.communicationType;
        },
        filter: filters.set,
      },
      {
        headerName: 'Status/Outcome',
        valueGetter: params => {
          return params.data.inboxMessage?.messageStatusLookup.descript ?? params.data.communicationOutcome;
        },
        filter: filters.set,
      },
      {
        headerName: 'Display Name',
        field: 'displayName',
      },
      {
        headerName: editable ? 'Message (double click to edit)' : 'Message',
        cellEditor: 'agLargeTextCellEditor',
        cellEditorParams: { maxLength: 1000 },
        editable: true,
        field: 'message',
        valueGetter: params => {
          return params.data.inboxMessage?.inboxMessage1 ?? params.data.message;
        },
        valueSetter: params => {
          if (params.data.inboxMessage) {
            params.data.inboxMessage.inboxMessage1 = params.newValue;
          }
          return true;
        },
        tooltipValueGetter: params => {
          return params.data.inboxMessage?.inboxMessage1 ?? params.data.message;
        },
        suppressKeyboardEvent: params =>
          params.editing && !!params?.data?.inboxMessage ? false : params.event.preventDefault(),
      },
      {
        headerName: 'Additional Notes',
        field: 'notes',
        cellEditor: 'agLargeTextCellEditor',
        cellEditorParams: { maxLength: 1000 },
        editable: true,
        suppressKeyboardEvent: params =>
          params.editing && !!params?.data?.inboxMessage ? false : params.event.preventDefault(),
        tooltipValueGetter: params => {
          return params.data.notes;
        },
      },
    ],
    [editable],
  );

  const getOrderCommunicationAsync = async () => {
    try {
      const res = await getOrderCommunication(orderLineId, { includePolicyHolderCommunication: true });
      setMessages(res.allCommunication);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateMessages = async (allRows, modifiedRows) => {
    for (let index = 0; index < modifiedRows.length; index++) {
      const row = modifiedRows[index];

      try {
        const { inboxMessage1, inboxMessageId } = row.inboxMessage;
        await updateCommunicationMessage(inboxMessageId, inboxMessage1);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleOnGridReady = ({ api }) => {
    window.api = api;
    api.sizeColumnsToFit();
  };

  useEffect(() => {
    getOrderCommunicationAsync();
  }, []);

  return (
    <AgGrid
      class="ag-tooltip-custom"
      gridName={gridName}
      gridData={messages}
      columnDefs={columnDefs}
      gridOptions={gridOptions}
      sideBar={false}
      floatingFilter={false}
      redirectOnClick={false}
      editOnClick={true}
      onSave={handleUpdateMessages}
      onGridReady={handleOnGridReady}
      tooltipMouseTrack={true}
    />
  );
};

CommunicationGrid.propTypes = {};

CommunicationGrid.defaultProps = {};

export default CommunicationGrid;
